module.exports = __webpack_public_path__ + "img/ognen-trajkovski.09f18776.jpg";